import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';

import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';
import { getSimpleVenuesTemplates } from '@go-client/lib/api/venueTemplate';
import { getPropertyEventTemplates } from '@go-client/lib/api/eventTemplate';
import { getDayTemplate } from '@go-client/lib/api/template';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';

export const DayTemplateEventLog: React.FC<UserActionLog> = ({ body, url }) => {
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        let fields = {};

        const urlParts = url!.split('/');
        const templateId = urlParts[2];
        if (templateId) {
          const template = await getDayTemplate(templateId).catch(_error =>
            console.error('Error loading template')
          );

          if (template) {
            const dayTemplateFields = FieldsReplacer(template.plan.day, logFields, [
              {
                from: 'name',
                to: 'day',
              },
            ]);
            fields = { ...fields, ...dayTemplateFields };
          }
        }

        // get venue information
        if (body.venue) {
          const venues = await getSimpleVenuesTemplates();
          const venue = venues.find(v => v._id === body.venue);
          if (venue) {
            const propertyFields = FieldsReplacer(venue, logFields, [
              {
                from: 'name',
                to: 'venue',
              },
            ]);

            fields = { ...fields, ...propertyFields };

            // get information about template
            const eventTemplates = await getPropertyEventTemplates(venue.property);
            const eventTemplate = eventTemplates.find(t => t._id === body.template)!;
            const eventTemplateFields = FieldsReplacer(eventTemplate, logFields, [
              {
                from: 'title',
                to: 'template',
              },
            ]);

            fields = { ...fields, ...eventTemplateFields };
          }
        }

        setLogFields({ ...logFields, ...fields });
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
